import axios from "axios";

export const blobToBase64 = (blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export const urlToObjectUrl = (url) => {
  return new Promise((resolve, _) => {
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob',
      // Ignore browser cache with this headers because otherwise if cached the cors headers are missing.
      // To improve maybe one could use the cached version?
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      resolve(url)
    });
  });
}

export const scaleToFitWithAspectRatio = (screenWidth, screenHeight, imageWidth, imageHeight) => {
  const imageRatio = imageWidth / imageHeight
  const screenRatio = screenWidth / screenHeight

  if (screenRatio > imageRatio) {
    return {width: imageWidth * (screenHeight/imageHeight), height: screenHeight}
  } else {
    return {width: screenWidth, height: imageHeight * (screenWidth/screenHeight)}
  }
}
